import classNames from 'classnames';
import React from 'react';

import styles from '../../../styles/partials/loading-bar.module.css';

interface LoadingBarProps {
    loading?: boolean;
    loaded?: boolean;
    color?: string | null;
    className?: string | null;
    barClassName?: string | null;
}

function LoadingBar({
    loading = false,
    loaded = false,
    color = null,
    className = null,
    barClassName = null,
}: LoadingBarProps) {
    return (
        <div
            className={classNames([
                'fullscreen',
                styles.container,
                {
                    [styles.loading]: loading,
                    [styles.loaded]: loaded,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames({
                    [styles.bar]: true,
                    [barClassName]: barClassName !== null,
                })}
                style={
                    color ? ({ '--loading-color': color } as React.CSSProperties) : undefined
                }
            />
        </div>
    );
}

export default LoadingBar;
